import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, Trash2 } from 'lucide-react';

/**
 * StatsListEditor — edit an array of { label, value } objects.
 * Used for structured statistics on Sector Achievements.
 *
 * Props:
 * - value: [{ label, value }]
 * - onChange: (nextArray) => void
 * - testId?: string
 */
export const StatsListEditor = ({ value = [], onChange, testId }) => {
    const items = Array.isArray(value) ? value : [];

    const update = (idx, patch) => {
        const next = items.map((it, i) => (i === idx ? { ...it, ...patch } : it));
        onChange && onChange(next);
    };

    const add = () => onChange && onChange([...items, { label: '', value: '' }]);
    const remove = (idx) =>
        onChange && onChange(items.filter((_, i) => i !== idx));

    return (
        <div className="space-y-2" data-testid={testId}>
            {items.map((it, idx) => (
                <div key={idx} className="flex gap-2 items-center">
                    <Input
                        value={it.label || ''}
                        onChange={(e) => update(idx, { label: e.target.value })}
                        placeholder="Label (e.g. Placements)"
                        className="flex-1"
                        data-testid={testId ? `${testId}-label-${idx}` : undefined}
                    />
                    <Input
                        value={it.value || ''}
                        onChange={(e) => update(idx, { value: e.target.value })}
                        placeholder="Value (e.g. 2.15 Lakh+)"
                        className="flex-1"
                        data-testid={testId ? `${testId}-value-${idx}` : undefined}
                    />
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => remove(idx)}
                        className="text-destructive hover:text-destructive shrink-0"
                        data-testid={testId ? `${testId}-remove-${idx}` : undefined}
                    >
                        <Trash2 className="h-4 w-4" />
                    </Button>
                </div>
            ))}
            <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={add}
                data-testid={testId ? `${testId}-add` : undefined}
            >
                <Plus className="h-3.5 w-3.5 mr-1.5" /> Add row
            </Button>
        </div>
    );
};

export default StatsListEditor;
